import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import { observer, inject, PropTypes as MobXProptypes } from "mobx-react";
import { Utils, Button } from "arv-reactcomponents";

import FilterList from "../../FilterList";
import OmniFilter from "../OmniFilter";
import { filterInitialLength, LISTING } from "npmlinks-constants";
import PriceFilter from "../../PriceFilter";
import FilterActionsWrapper from "../../FilterActionsWrapper";
import SizeNudgeBlock from "../SizeNudgeBlock";

@inject("ProductStore", "CommonStore")
@observer
class OmniAndOtherFilters extends Component {
  constructor(props) {
    super(props);
    this.state = {
      initialLength: filterInitialLength,
      toggleShowMore: false,
      filterChanges: 1,
      selectedFiltersCount: 0,
      customPriceFilterView: false,
    };
    this.moreButtonClick = this.moreButtonClick.bind(this);
    this.lessButtonClick = this.lessButtonClick.bind(this);
    this.rerenderFilter = this.rerenderFilter.bind(this);
    this.getMaxHeight = this.getMaxHeight.bind(this);
    this.customPriceFiltersApplied = this.customPriceFiltersApplied.bind(this);
    this.disableCustomPriceView = this.disableCustomPriceView.bind(this);
  }
  componentDidMount() {
    const { ProductStore } = this.props;
    // eslint-disable-next-line react/no-did-mount-set-state
    this.setState({
      customPriceFilterView: ProductStore.customPriceFilters.length > 0,
    });
  }

  componentWillReceiveProps(nextProps) {
    if (
      this.props.showLess !== nextProps.showLess ||
      nextProps.ProductStore.ProductData.selectedFilters.length !==
      this.state.selectedFiltersCount
    ) {
      this.setState({
        initialLength: filterInitialLength,
        toggleShowMore: false,
        selectedFiltersCount:
          nextProps.ProductStore.ProductData.selectedFilters.length,
      });
      this.props.action(false);
    }
  }

  get showPriceButton() {
    const { eachfilterBy, ProductStore } = this.props;
    return (
      eachfilterBy.filterType === "Price" &&
      ProductStore.customPriceFilters.length > 0 &&
      this.state.customPriceFilterView
    );
  }

  get getDelieveryTimeClass() {
    return (
      ((this.props.eachfilterBy.filterType === "delivery_time" ||
        this.props.eachfilterBy.filterType === "nearby_stores") &&
        "nw-omniandotherfilters-addon") ||
      ""
    );
  }

  get isHideMoreClassName() {
    return (
      ((this.state.toggleShowMore ||
        this.props.eachfilterBy.list.length <= filterInitialLength) &&
        "nwc-hide") ||
      ""
    );
  }
  get isShowLessClassName() {
    return (!this.state.toggleShowMore && "nwc-hide") || "";
  }

  getMaxHeight(eachfilterBy) {
    const { isDesktop } = this.props.CommonStore;
    if (!isDesktop) {
      return null;
    }
    if (eachfilterBy.list.length && this.state.toggleShowMore) {
      return this.wrapperRef && this.wrapperRef.offsetHeight;
    }
    return null;
  }

  rerenderFilter() {
    this.setState({ filterChanges: this.state.filterChanges + 1 });
  }
  moreButtonClick() {
    this.setState({
      initialLength: this.props.eachfilterBy.list.length,
      toggleShowMore: !this.state.toggleShowMore,
    });
    this.props.action(true);
  }

  lessButtonClick() {
    this.setState({
      initialLength: filterInitialLength,
      toggleShowMore: !this.state.toggleShowMore,
    });
    this.props.action(false);
  }
  customPriceFiltersApplied() {
    this.setState({ customPriceFilterView: true });
  }
  disableCustomPriceView() {
    this.setState({ customPriceFilterView: false });
  }

  render() {
    const {
      eachfilterBy,
      className,
      isFilterOpen,
      isSizeSelected,
    } = this.props;
    const { callCount } = this.props.ProductStore;
    if (!eachfilterBy) return null;
    return (
      <div>
        {isFilterOpen && eachfilterBy.filterType === "delivery_time" && (
          <div>
            <OmniFilter.component
              eachfilterBy={eachfilterBy}
              placeholder="Enter your pincode"
              className={className}
              mapping={eachfilterBy.mapping}
              list={eachfilterBy.list}
              type={eachfilterBy.filterType}
              rerenderFilter={this.rerenderFilter}
            />
          </div>
        )}
        {isFilterOpen && eachfilterBy.filterType === "nearby_stores" && (
          <div>
            {!isSizeSelected ? <SizeNudgeBlock.component /> : null}
            <OmniFilter.component
              eachfilterBy={eachfilterBy}
              placeholder="Enter your pincode"
              className={className}
              mapping={eachfilterBy.mapping}
              list={eachfilterBy.list}
              type={eachfilterBy.filterType}
            />
          </div>
        )}
        {callCount && isFilterOpen && eachfilterBy.list.length > 0 && (
          <Fragment>
            {!this.showPriceButton && (
              <ul
                ref={context => {
                  this.wrapperRef = context;
                }}
                style={{ maxHeight: this.getMaxHeight(eachfilterBy) }}
                className={`nw-omniandotherfilters-wrapper ${
                  this.getDelieveryTimeClass
                  }`}
              >
                {this.props.eachfilterBy.list
                  .slice(0, this.state.initialLength)
                  .map((eachlist, index) => (
                    <FilterList.component
                      key={eachlist.value || eachlist.min}
                      filterlist={eachlist}
                      name="All Filters"
                      index={index}
                      className={className}
                      mapping={eachfilterBy.mapping}
                      type={this.props.eachfilterBy.filterType}
                      filterTitle={this.props.filterTitle}
                    />
                  ))}
                <li
                  role="presentation"
                  onKeyPress={Utils.noop}
                  onClick={this.moreButtonClick}
                  className={`nw-omniandotherfilters-more ${
                    this.isHideMoreClassName
                    } ${className}`}
                >
                  More
                </li>
                <li
                  role="presentation"
                  onKeyPress={Utils.noop}
                  onClick={this.lessButtonClick}
                  className={`nw-omniandotherfilters-less ${
                    this.isShowLessClassName
                    } ${className}`}
                >
                  Less
                </li>
              </ul>
            )}
            {this.showPriceButton && (
              <div
                className={`${className} nw-listingpricefilter-allpricebuttoncontainer`}
              >
                <Button
                  className={`${className} nw-listingpricefilter-allpricebutton`}
                  onClick={this.disableCustomPriceView}
                >
                  <i
                    className={`${className} icomoon-arrow_left nw-listingpricefilter-allpricebuttonicon`}
                  />
                  {LISTING.PRICE_FILTER.ALL_PRICE_RANGES_BUTTONTEXT}
                </Button>
              </div>
            )}
            {eachfilterBy.filterType === "Price" && isFilterOpen && (
              <FilterActionsWrapper.component
                mapping={eachfilterBy.mapping}
                filterTitle={LISTING.PRICE_FILTER.FILTER_NAME}
              >
                <PriceFilter.component
                  mapping={eachfilterBy.mapping}
                  customPriceFiltersApplied={this.customPriceFiltersApplied}
                />
              </FilterActionsWrapper.component>
            )}
          </Fragment>
        )}
      </div>
    );
  }
}

OmniAndOtherFilters.wrappedComponent.defaultProps = {
  className: "",
};
OmniAndOtherFilters.wrappedComponent.propTypes = {
  ProductStore: PropTypes.shape({
    callCount: PropTypes.number.isRequired,
    ProductData: MobXProptypes.observableArray(
      PropTypes.shape({
        length: PropTypes.number.isRequired,
      }),
    ),
  }).isRequired,
  eachfilterBy: PropTypes.shape({
    list: PropTypes.oneOfType([
      PropTypes.shape({}).isRequired,
      PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    ]).isRequired,
    filterType: PropTypes.string.isRequired,
  }).isRequired,
  className: PropTypes.string,
  isFilterOpen: PropTypes.bool.isRequired,
  action: PropTypes.func.isRequired,
  showLess: PropTypes.bool.isRequired,
  filterTitle: PropTypes.string.isRequired,
  CommonStore: PropTypes.shape({
    isDesktop: PropTypes.bool.isRequired,
  }).isRequired,
};

const getFinalComponent = component =>
  inject("ProductStore", "CommonStore")(observer(component));

const ProjectComponent = {
  getFinalComponent,
  wrapper: OmniAndOtherFilters.wrappedComponent,
  component: OmniAndOtherFilters,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/ProductFilters/ProductFilterBlock/OmniAndOtherFilters/index.js